import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteModelAction } from '../../../redux/actions/modelsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const DeleteModelModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const brandId = useSelector((state) => state.models.brand?.id);
  const modelId = useSelector((state) => state.models?.model?.id);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteModelAction(modelId, brandId));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення моделі'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю модель?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteModelModal;
